import Select from 'react-select';
import './dropdown.scss';

interface DropdownElementInterface {
    authorizingUser: string;
    companyDocID: string;
    companyDocType: string;
    date: string;
    label: string;
    serviceId: string;
    value: number;
}

interface DropdownInterface {
    placeholder: string;
    selectedValue: undefined | DropdownElementInterface;
    setSelectedValue: (selectedValue) => void;
    options: any;
}

const Dropdown = ({
    selectedValue,
    setSelectedValue,
    placeholder,
    options,
}: DropdownInterface) => {
    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#ff277e',
        }),
        placeholder: (provided) => ({
            ...provided,
            fontFamily: 'roboto-regular',
            whiteSpace: 'nowrap',
            fontSize: '0.91429rem',
            color: '#6F7287',
        }),
        option: (provided, state) => ({
            ...provided,
            fontFamily: 'roboto-regular',
            fontSize: '0.91429rem',
            color: '#36373A',
            backgroundColor: state.isSelected ? '#FFF5F9' : '#FFFFFF',
            '&:hover': {
                backgroundColor: '#FFF5F9',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
            fontFamily: 'roboto-regular',
            color: '#6F7287',
            fontSize: '0.91429rem',
        }),
        noOptionsMessage: (provided) => ({
            ...provided,
            fontFamily: 'roboto-regular',
        }),
        input: (provided) => ({
            ...provided,
            fontFamily: 'roboto-regular',
        }),
        control: () => ({
            display: 'flex',
            border: '1px solid #DBDBDB',
            borderRadius: '0px',
        }),
    };

    const onChange = (event) => {
        setSelectedValue(event);
    };

    return (
        <div className="a-dropdown">
            <p className="a-dropdown-label">Identificación empresarial</p>
            <Select
                options={options}
                isSearchable
                maxMenuHeight={150}
                placeholder={placeholder}
                styles={customStyles}
                onChange={onChange}
                value={selectedValue}
                noOptionsMessage={() => 'No se encontraron resultados'}
            />
        </div>
    );
};

export default Dropdown;
